import { Injectable } from '@angular/core';
import { Response, Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient } from './http-client';
import { Router } from '@angular/router';

@Injectable()
export class DolarizacionService {

  constructor(private httpClient: HttpClient,
              private router: Router,
              private http: Http) {}

  getDolarizacion(filter) {
    return this.httpClient.post(`/api/dolarizacion/solicitud/filter`, filter)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getDolarizacionHistory(filter) {
    return this.httpClient.post(`/api/dolarizacion/solicitud/history-filter`, filter)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  sendDolarizacion(payload) {
    return this.httpClient.put(`/api/dolarizacion/solicitud`, payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/dolarizacion-service.ts